import { AutogenLayoutLoadTenderExpressProfileList } from "./autogen/AutogenLayoutLoadTenderExpressProfileList";

export class LoadTenderExpressProfileList extends AutogenLayoutLoadTenderExpressProfileList {
    override onLoad() {
        this.mainDataSource.search({});
    }
}